import * as types from './types'
import storage from '@/Plugins/storage'

export default () => ({
  pager: storage.session.getItem(types.STORE_PAGER)
    ? JSON.parse(storage.session.getItem(types.STORE_PAGER))
    : {
        pageSize: 10,
        orderBy: 'asc',
        sortBy: null,
        search: null,
        total: 0,
        page: 1,
        pages: 1,
      },
  isChecked: false,
  defaultProgram: {
    DisplayName: '',
    EndDate: null,
    GoalCardioCalories: 0,
    HRmax: 190,
    IsActive: true,
    LowerPercent: 65,
    MinutesAboveZone: 30,
    MinutesBelowZone: 0,
    MinutesInZone: 90,
    Name: '',
    StartDate: null,
    Time: 120,
    UpperPercent: 85,
    createdby_id: null,
    id: null,
    organization_id: null,
    orgcode: null,
  },
  orgcode: null,
  program: null,
  programs: [],
})
